import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { handleRedirectCallback, isAuthenticated, login } from "../lib/auth";

interface AuthContextValue {
  ready: boolean; // callback processed
  authed: boolean;
  signIn: () => void;
}

const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);
  const [authed, setAuthed] = useState(isAuthenticated());

  useEffect(() => {
    let active = true;
    void handleRedirectCallback()
      .then((signedIn) => {
        if (!active) return;
        if (signedIn) setAuthed(true);
      })
      .finally(() => active && setReady(true));
    return () => {
      active = false;
    };
  }, []);

  return (
    <AuthContext.Provider value={{ ready, authed, signIn: () => void login() }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
